import React from "react";
import { Link } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import navLogo from "../../images/nav-logo.png";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { components } from "../../utils/rt-mods";
import { colorCheck } from "../../utils/accessibility-helpers";

// Label Component
const Label = ({ text, variant = "default", theme }) => {
  if (!text) return null;

  const getClassNames = () => {
    switch (variant) {
      case "large":
        return `label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 md:mb-2 text-${colorCheck(theme)}`;
      case "graphic":
        return "bottom-7 left-7 absolute bg-black bg-opacity-60 inline-block pr-1 pl-2 pt-1 pb-1 rounded font-bold uppercase tracking-widest text-vs text-white";
      case "basic-resource":
        return "font-bold uppercase tracking-widest text-vs text-teal";
      case "basic-custom":
        return `font-bold uppercase tracking-widest text-vs py-1 px-3 bg-grey-light rounded mb-2 text-${colorCheck(theme)}`;
      default:
        return "font-bold uppercase tracking-widest text-xs";
    }
  };

  const wrapperClass = variant === "basic-resource" ? "flex gap-2 items-center mb-2" : "";

  return wrapperClass ? (
    <span className={wrapperClass}>
      <span className={getClassNames()}>{text}</span>
    </span>
  ) : (
    <div className={getClassNames()}>{text}</div>
  );
};

const CardNormal = (props) => {

    const card = props.card


            return (
              <>
                {props.sc.card_layout === "large" ? (
                  card.card_content_type === "Resource" ? (
                    <Link
                      to={card.resource.document.url}
                      className={
                        "flex flex-col md:flex-row justify-between gap-12 items-center " +
                        card.theme
                      }
                    >
                      <div className="w-auto self-start md:w-1/2">
                        <GatsbyImage
                          image={getImage(card.resource.document.data.meta_image)}
                          alt={
                            card.resource.document.data.meta_image.alt ||
                            card.resource.document.data.resource_title.text
                          }
                          className="rounded-lg shadow-xl"
                        />
                      </div>
                      <div className="w-auto md:w-1/2">
                        {card.resource.type === "navigation_insider" ? (
                          <img
                            loading="lazy"
                            src={navLogo}
                            alt="Navigation Insider"
                            className="inline-block pb-5 mb-5 border-b border-grey-md md:w-2/4"
                          />
                        ) : (
                          ""
                        )}
                        <Label text={card.card_label} variant="large" theme={card.theme} />
                        <h3 className="text-2xl font-ave">
                          {card.resource.document.data.resource_title.text}
                        </h3>
                        <p>{card.resource.document.data.description.text}</p>
                        {card.resource_type === "video" ? (
                          <div className="btn text-sm bg-teal-dark">
                            <i className="fa-regular fa-circle-play mr-1" />{" "}
                            {card.button_label}
                          </div>
                        ) : (
                          <div className={"btn text-sm bg-" + colorCheck(card.theme)}>
                            {card.button_label}
                          </div>
                        )}
                      </div>
                    </Link>
                  ) : (
                    <Link
                      to={card.custom_link.url} 
                      className={
                        "flex flex-col md:flex-row justify-between gap-12 items-center " +
                        card.theme
                      }
                    >
                      <div className="w-auto md:w-1/2">
                        <GatsbyImage
                          image={getImage(card.custom_image)}
                          alt={card.custom_image.alt || card.custom_title}
                          className="rounded-lg shadow-lg"
                        />
                      </div>
                      <div className="w-auto md:w-1/2">
                        <Label text={card.card_label} variant="large" theme={card.theme} />
                        <h3>{card.custom_title}</h3>
                        <PrismicRichText field={card.custom_content.richText} />
                        {card.resource_type === "video" ? (
                          <div className="btn text-sm bg-teal-dark">
                            <i className="fa-regular fa-circle-play mr-1" />{" "}
                            {card.button_label}
                          </div>
                        ) : (
                          <div className={"btn text-sm bg-" + colorCheck(card.theme)}>
                            {card.button_label}
                          </div>
                        )}
                      </div>
                    </Link>
                  )
                ) : props.sc.card_layout === "graphic" ? (
                  card.card_content_type === "Resource" ? (
                    <Link to={card.resource.document.url} className={props.slide == 'slider-card' ? "slider-card" : "card"}>
                      <span>
                        <span className="relative block">
                          <GatsbyImage
                            image={getImage(
                              card.resource.document.data.meta_image
                            )}
                            alt={
                              card.resource.document.data.meta_image.alt ||
                              card.resource.document.data.resource_title.text
                            }
                            className="rounded-t-lg"
                          />
                          <Label text={card.card_label} variant="graphic" />
                          {card.resource_type === "video" ? (
                            <div className="absolute right-4 bottom-4 text-5xl text-white">
                              <i className="fa-regular fa-circle-play" />
                            </div>
                          ) : (
                            ""
                          )}
                        </span>
                        <span className="p-7 block">
                          <span className="title text-xl font-bold mb-3 pr-6 block leading-tight">
                            <PrismicRichText
                              field={
                                card.resource.document.data.resource_title
                                  .richText
                              }
                              components={components}
                            />
                          </span>
                          <p className="mb-0">
                            {card.resource.document.data.description.text}
                          </p>
                        </span>
                      </span>
                      <span className="pb-7 pr-7 pl-7 block">
                        {card.resource_type === "video" ? (
                          <div className="btn text-sm bg-teal-dark">
                            <i className="fa-regular fa-circle-play mr-1" />{" "}
                            {card.button_label}
                          </div>
                        ) : (
                          <div className={"btn text-sm bg-" + colorCheck(card.theme)}>
                            {card.button_label}
                          </div>
                        )}
                      </span>
                    </Link>
                  ) : (
                    <Link to={card.custom_link.url} target={card.custom_link.target || '_self'} rel="noopener noreferrer" className={props.slide == 'slider-card' ? "slider-card" : "card cus"}>
                      <span>
                        <span className="relative block">
                          <GatsbyImage
                            image={getImage(card.custom_image)}
                            alt={card.custom_image.alt || card.custom_title}
                            className="rounded-t-lg"
                          />
                          <Label text={card.card_label} variant="graphic" />
                        </span>
                        <span className="p-7 block">
                          <span className="title text-xl font-bold mb-3 pr-6 block leading-tight">
                            {card.custom_title}
                          </span>
                          <PrismicRichText
                            field={card.custom_content.richText}
                            components={components}
                          />
                        </span>
                      </span>
                      <span className="pb-7 pr-7 pl-7 block">
                        {card.resource_type === "video" ? (
                          <div className="btn text-sm bg-teal-dark">
                            <i className="fa-regular fa-circle-play mr-1" />{" "}
                            {card.button_label}
                          </div>
                        ) : (
                          <div className={"btn text-sm bg-" + colorCheck(card.theme)}>
                            {card.button_label}
                          </div>
                        )}
                      </span>
                    </Link>
                  )
                ) : card.card_content_type === "Resource" ? (
                  <Link
                    to={card.resource.document.url}
                    className="card-basic p-7 teal"
                  >
                    <span>
                      <Label text={card.card_label} variant="basic-resource" />
                      <span className="title text-2xl font-bold mb-3 pr-6 block leading-tight"></span>
                      <p className="mb-0"></p>
                    </span>
                    <span>
                      {card.resource_type === "video" ? (
                        <div className="btn text-sm bg-teal-dark">
                          <i className="fa-regular fa-circle-play mr-1" />{" "}
                          {card.button_label}
                        </div>
                      ) : (
                        <div className={"btn text-sm bg-" + colorCheck(card.theme)}>
                          {card.button_label}
                        </div>
                      )}
                    </span>
                  </Link>
                ) : (
                  <Link
                    to={card.custom_link.url}
                    className={"card-basic cus p-7 " + card.theme}
                  >
                    <span>
                      <span className="flex gap-2 items-center mb-2">
                        <Label text={card.card_label} variant="basic-custom" theme={card.theme} />
                      </span>
                      <span
                        className={
                          "title text-2xl font-bold mb-3 pr-6 block leading-tight text-" +
                          card.theme
                        }
                      >
                        {card.custom_title}
                      </span>
                      <PrismicRichText
                        field={card.custom_content.richText}
                        components={components}
                      />
                    </span>
                    <span>
                      {card.resource_type === "video" ? (
                        <div className="btn text-sm bg-teal-dark">
                          <i className="fa-regular fa-circle-play mr-1" />{" "}
                          {card.button_label}
                        </div>
                      ) : (
                        <div className={"btn text-sm bg-" + colorCheck(card.theme)}>
                          {card.button_label}
                        </div>
                      )}
                    </span>
                  </Link>
                )}
              </>
            );
          }

export default CardNormal;
